import { Component, OnInit } from '@angular/core';
import { CurrentDay } from './currentDay';
import { CurrentDayService } from '../services/current-day.service';

@Component({
  selector: 'app-current-snapshot',
  templateUrl: './current-snapshot.component.html',
  styleUrls: ['./current-snapshot.component.scss']
})
export class CurrentSnapshotComponent implements OnInit {

  editID: number;
  showOptions = 0;
  currentDay: CurrentDay[];
  inProgress: CurrentDay[] = [];
  sentHome: CurrentDay[] = [];
  onCal: CurrentDay[] = [];

  constructor(private curDayService: CurrentDayService) { }

  ngOnInit(): void {
    this.getCurrentDay();
  }

  showOptionButtons(id?: number) {
    this.showOptions = id;
  }

  getCurrentDay() {
    this.curDayService.getCurrentDay()
      .subscribe(
        res => {
          this.currentDay = res;
          this.setInProgress();
        }
      );
  }

  setInProgress() {
    this.currentDay.forEach(el => {
      if (el.STATUS === 1) {
        this.onCal.push(el);
      } else if (el.STATUS === 2) {
        this.inProgress.push(el);
      } else if (el.STATUS === 3) {
        this.sentHome.push(el);
      }
    });
  }



}
